import { Injectable } from '@angular/core';
import { Child } from '../interfaces/child.interface';
import { SaveDataForm } from '../interfaces/saveFormData';
import { Subject ,  BehaviorSubject } from 'rxjs';


@Injectable()
export class DataSaveService {
    newCustomer: any = {};
    lastChild: Child;
    saveData: SaveDataForm;
    data: any = {};
    step: any = {};
    nombreVista: any = {};
    tab: any = {};
    formulario: any = {};
    formularioStock: any = {};
    formularioGestion: any = {};
    formularioCompraVehic: any = {};
    formularioCaractVehic: any = {};
    formularioCarroceria: any = {};
    public resetBotonera = new Subject<boolean>();
    modulo: number;
    child: Child;
    istheSameModule: boolean;
    istheSameSection: boolean;
    lastSection = 900; // Home-principal
    datosRowTabla: any = {};
    ordenSeleccionada: any = {};
    chassis: any = {};
    objetoPaginacion: any = {};
    escogidoAbc: any = {};
    $sameSection = new BehaviorSubject<boolean>(this.istheSameSection);
    canEditVehicleSubject = new BehaviorSubject<any>(false);
    canEditVehicle = this.canEditVehicleSubject.asObservable();
    // public escogidoAbc = new BehaviorSubject<any>({ id: 1, name: 'A', value: 'A', activado:  true  });

    constructor() {
        this.step = { 'step': 0 };
        this.nombreVista = { 'nombreVista': '' };
        this.tab = { 'tab': 0 };
        this.chassis = { 'chassis': '' };
        this.istheSameModule = false;
        this.newCustomer = {
            'isNew': false
        };
        this.objetoPaginacion = {
            'skip': 0,
            'pageNumber': 1,
            'pageSize': 20
        };
        this.escogidoAbc = {
            'activado': true,
            'id': 1,
            'name': 'A',
            'value': 'A'
        };
    }

    setCanEditVehicle(value: boolean){
        this.canEditVehicleSubject.next(value);
    }

    getCanEditVehicle(): boolean{
        return this.canEditVehicleSubject.getValue();
    }

    observerResetBotonera() {
        return this.resetBotonera.asObservable();
    }
    setResetBotonera(value) {
        this.resetBotonera.next(value);
    }


    // Paginacion Tablas
    getAbecedario(idData: string) {
        return this.escogidoAbc[idData] ? this.escogidoAbc[idData] : null;
    }
    setAbecedario(idData: string, content: any) {
        this.escogidoAbc[idData] = content;
    }


    getCustomerNew(idData: string) {
        return (this.newCustomer[idData] ? this.newCustomer[idData] : null);
    }

    setCustomerNew(idData: string, content: any) {
        this.newCustomer[idData] = content;
    }

    getData(idData: string) {
        return (this.data[idData] ? this.data[idData] : null);
    }

    setData(idData: string, content: any) {
        this.data[idData] = content;
    }


    clearData(idData: string) {
        this.data[idData] = {};
    }

    // Fila escogida de la tabla
    getOR(idData: string) {
        return this.ordenSeleccionada[idData] ? this.ordenSeleccionada[idData] : null;
    }
    setOR(idData: string, content: any) {
        this.ordenSeleccionada[idData] = content;
    }


    // Datos de la tabla
    getDatosRowTabla(idData: string) {
        return this.datosRowTabla[idData] ? this.datosRowTabla[idData] : null;
    }
    setDatosRowTabla(idData: string, content: any) {
        this.datosRowTabla[idData] = content;
    }


    // Fila escogida solo para el Chassis
    getChassis(idData: string) {
        return this.chassis[idData] ? this.chassis[idData] : null;
    }
    setChassis(idData: string, content: any) {
        this.chassis[idData] = content;
    }
    // Paginacion Tablas
    getDatosPaginacion(idData: string) {
        return this.objetoPaginacion[idData] ? this.objetoPaginacion[idData] : null;
    }
    setDatosPaginacion(idData: string, content: any) {
        this.objetoPaginacion[idData] = content;
    }

    // guardado de pasos vista wizzard
    getStepsView(idData: string) {
        return (this.step[idData] ? this.step[idData] : null);
    }
    setStepsView(idData: string, content: any) {
        this.step[idData] = content;
    }

    // guardado de vistas dentro de cada paso wizzard
    getNameScreen(idData: string) {
        return (this.nombreVista[idData] ? this.nombreVista[idData] : null);
    }
    setNameScreen(idData: string, content: any) {
        this.nombreVista[idData] = content;
    }

    // guardado de pasos pestañas
    getTabsView(idData: string) {
        return (this.tab[idData] ? this.tab[idData] : null);
    }

    setTabsView(idData: string, content: any) {
        this.tab[idData] = content;
    }

    // guardado del formulario
    getFormulario(idData: string) {
        return (this.formulario[idData] ? this.formulario[idData] : null);
    }

    setFormulario(idData: string, content: any) {
        this.formulario[idData] = content;
    }







    // guardado del formulario
    getFormularioGestion(idData: string) {
        return (this.formularioGestion[idData] ? this.formularioGestion[idData] : null);
    }
    setFormularioGestion(idData: string, content: any) {
        this.formularioGestion[idData] = content;
    }

    getFormularioCaractVehic(idData: string) {
        return (this.formularioCaractVehic[idData] ? this.formularioCaractVehic[idData] : null);
    }
    setFormularioCaractVehic(idData: string, content: any) {
        this.formularioCaractVehic[idData] = content;
    }

    getFormularioCompraVehic(idData: string) {
        return (this.formularioCompraVehic[idData] ? this.formularioCompraVehic[idData] : null);
    }
    setFormularioCompraVehic(idData: string, content: any) {
        this.formularioCompraVehic[idData] = content;
    }

    // guardado del formulario
    getFormularioCarroceria(idData: string) {
        return (this.formularioCarroceria[idData] ? this.formularioCarroceria[idData] : null);
    }
    setFormularioCarroceria(idData: string, content: any) {
        this.formularioCarroceria[idData] = content;
    }

    //  Para saber si estamos en el mismo modulo
    setModule(content: any) {
        const lastModule = JSON.parse(sessionStorage.getItem('moduleActualizado'));
        this.modulo = content;
        if (lastModule !== 0 && lastModule === this.modulo) {
            this.istheSameModule = true;
        } else {
            this.istheSameModule = false;
        }
        sessionStorage.setItem('istheSameModule', JSON.stringify(this.istheSameModule));
        sessionStorage.setItem('moduleActualizado', JSON.stringify(this.modulo));
    }
    //  Para saber si estamos en la misma seccion
    setChild(content: Child) {
        this.lastChild = JSON.parse(sessionStorage.getItem('optionMenu'));
        this.child = content;
        if (this.lastChild && this.lastChild.ID === this.child.ID) {
            this.istheSameSection = true;
        } else {
            this.istheSameSection = false;
        }
        this.$sameSection.next(this.istheSameSection);

        sessionStorage.setItem('istheSameSection', JSON.stringify(this.istheSameSection));
    }



    clearAll() {
        this.newCustomer = {};
        this.data = {};
        this.datosRowTabla = {};
        this.chassis = {};
        this.objetoPaginacion = {};
        this.step = {};
        this.tab = {};
        this.formulario = {};
        this.formularioGestion = {};
        this.formularioCarroceria = {};
        this.escogidoAbc = {};
    }



}
